export const getLatestMilestoneEndDate = (initiative) => {
  if (
    !initiative ||
    !initiative.milestones ||
    !Array.isArray(initiative.milestones) ||
    initiative.milestones.length === 0
  ) {
    return null;
  }

  let latestEndDate = null;

  initiative.milestones.forEach((milestone) => {
    const endDate = milestone.endDate ? new Date(milestone.endDate) : null;

    if (endDate) {
      if (!latestEndDate || endDate > latestEndDate) {
        latestEndDate = endDate;
      }
    }
  });

  return latestEndDate ? latestEndDate.toISOString().split('T')[0] : null;
};
